import React from 'react'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'
import media from '../../utils/media'

const Container = styled.div`
  margin: ${props => props.btnMarginT}px auto
    ${props => props.btnMarginB}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  ${media.mobileL`
    margin: calc(${props =>
      props.btnMarginT}px - 10px) auto calc(${props =>
    props.btnMarginB}px / 1.5);
  `}
`

const Button = styled.a`
  height: 50px;
  width: ${props => (props.btnWidth ? `${props.btnWidth}` : '262px')};
  background-color: ${props => props.btnBg} !important;
  color: ${props => props.btnColor} !important;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 1.85px;
  line-height: 21px;
  white-space: nowrap;
  vertical-align: middle;
  padding: 15px;
  border: none;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  &:hover {
    text-decoration: none !important;
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  &:active {
    opacity: 0.7;
  }
  ${media.mobileL`
    width: ${props => props.btnWidthMobile && props.btnWidthMobile};
  `}
`
export default function Btn({
  btnText,
  href,
  btnBg,
  btnColor,
  btnMarginT,
  btnMarginB,
  btnWidthMobile,
  btnWidth,
  optional,
}) {
  const textToShow = useTranslations(btnText, { optional })
  const hrefBtn = useTranslations(href, {})
  if (optional && textToShow === null) return null
  return (
    <Container btnMarginT={btnMarginT} btnMarginB={btnMarginB}>
      <Button
        href={hrefBtn}
        btnBg={btnBg}
        btnColor={btnColor}
        btnWidth={btnWidth}
        btnWidthMobile={btnWidthMobile}
      >
        <Text id={btnText} />
      </Button>
    </Container>
  )
}
